export const AiActivityTestIds = {
  CONTAINER: 'AiActivity_Container',
  OVERVIEW_CARD: 'AiActivity_OverviewCard',
  LIVE_CARD: 'AiActivity_LiveCard',
  RUN_HISTORY_CARD: 'AiActivity_RunHistoryCard',
  RUN_HISTORY_LIST: 'AiActivity_RunHistoryList',
  RUN_ROW: 'AiActivity_RunRow',
  RUN_ROW_EXPANSION: 'AiActivity_RunRow_Expansion',
  EXECUTION_DRAWER: 'AiActivity_ExecutionDrawer',
  EXECUTION_DRAWER_CLOSE: 'AiActivity_ExecutionDrawerClose',
  EMPTY_STATE: 'AiActivity_EmptyState',
  RUN_HISTORY_SKELETON: 'AiActivity_RunHistorySkeleton',
  FIRST_RUN_STATE: 'AiActivity_FirstRunState',
  RUN_HISTORY_ERROR_STATE: 'AiActivity_RunHistoryErrorState',
  STEP_MESSAGES_SKELETON: 'AiActivity_StepMessagesSkeleton',
  STEP_MESSAGES_ERROR_STATE: 'AiActivity_StepMessagesErrorState',
  SEARCH_INPUT: 'AiActivity_SearchInput',
  STATUS_FILTER: 'AiActivity_StatusFilter',
  GROUP_BY_TOGGLE: 'AiActivity_GroupByToggle',
  TECHNICAL_DETAILS_TOGGLE: 'AiActivity_TechnicalDetailsToggle',
  START_AI_PROCESS_BUTTON: 'AiActivity_StartAiProcessButton',
  START_AI_PROCESS_DRAWER: 'AiActivity_StartAiProcessDrawer',
  STEP_TOOL_CALLS_TAB: 'AiActivity_StepToolCallsTab',
  STEP_TOOL_CALLS_CONTENT: 'AiActivity_StepToolCallsContent',
  STEP_TOOL_CALLS_FINAL_OUTPUT: 'AiActivity_StepToolCallsFinalOutput',
  STEP_NAV_RAIL: 'AiActivity_StepNavRail',
  STEP_NAV_ROW: 'AiActivity_StepNavRow',
  STEP_NAV_ROW_BLOCKED: 'AiActivity_StepNavRow_Blocked',
  STEP_NAV_PARALLEL_GROUP: 'AiActivity_StepNavParallelGroup',
  STEP_NAV_ROW_REASON: 'AiActivity_StepNavRow_Reason',
  STEP_DETAIL_PANE: 'AiActivity_StepDetailPane',
  RUN_PROGRESS_METER: 'AiActivity_RunProgressMeter',
  RUN_TIMELINE: 'AiActivity_RunTimeline',
  RUN_TIMELINE_BAR: 'AiActivity_RunTimelineBar',
  RUN_TIMELINE_SUMMARY: 'AiActivity_RunTimelineSummary',
  RUN_TIMELINE_TOGGLE: 'AiActivity_RunTimelineToggle',
  RUN_SNAPSHOT: 'AiActivity_RunSnapshot',
  RUN_SNAPSHOT_STAT: 'AiActivity_RunSnapshotStat',
  TRIGGER_AVATAR: 'AiActivity_TriggerAvatar',
  RUN_FAILURE_RETRY: 'AiActivity_RunFailureRetry',
  RUN_FAILURE_RETRY_CONFIRM: 'AiActivity_RunFailureRetryConfirm',
  RUN_FAILURE_RETRY_FROM_HERE: 'AiActivity_RunFailureRetryFromHere',
  RUN_FAILURE_RETRY_FROM_HERE_CONFIRM: 'AiActivity_RunFailureRetryFromHereConfirm',
  RUN_FAILURE_COPY_DIAGNOSTICS: 'AiActivity_RunFailureCopyDiagnostics',
};
